import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { LoggedInGuard } from './auth/guards/logged-in.guard';
import { LoginLayoutComponent } from './layouts/login-layout/login-layout.component';
import { BaseLayoutComponent } from './layouts/base-layout/base-layout.component';
import { NotLoggedInGuard } from './auth/guards/not-logged-in.guard';

const routes: Routes = [

  {
    path: "",
    component: BaseLayoutComponent,
    children: [
      {
        path: "dashboard",
        loadChildren: () => import("./pages/dashboard/dashboard.module").then(m => m.DashboardModule),
        canActivate: [LoggedInGuard]
      },
      {
        path: "profile",
        loadChildren: () => import("./pages/profile/profile.module").then(m => m.ProfileModule),
        canActivate: [LoggedInGuard]
      },
      {
        path: "retailers-list",
        loadChildren: () => import("./pages/brand/list-retailer-brand/list-retailer-brand.module").then(m => m.ListRetailerBrandComponentModule),
        canActivate: [LoggedInGuard]
      },
      {
        path: "warehouse",
        loadChildren: () => import("./pages/warehouse/warehouse.module").then(m => m.WarehouseModule),
        canActivate: [LoggedInGuard]
      },
      {
        path: "brands",
        loadChildren: () => import("./pages/retailer/list-brand-retailer/list-brand-routing.module").then(m => m.ListBrandRoutingModule),
        canActivate: [LoggedInGuard]
      },
      {
        path: "orders",
        loadChildren: () => import("./pages/order/order-routing.module").then(m => m.OrderRoutingModule),
        canActivate: [LoggedInGuard]
      },
      {
        path: "campionari",
        loadChildren: () => import("./pages/campionari/campionari-routing.module").then(m => m.CampionariRoutingModule),
        canActivate: [LoggedInGuard]
      },
      {
        path: "clienti",
        loadChildren: () => import("./pages/clienti/clienti-routing.module").then(m => m.ClientiRoutingModule),
        canActivate: [LoggedInGuard]
      },
      {
        path: "agenti",
        loadChildren: () => import("./pages/agenti/agenti-routing.module").then(m => m.AgentiRoutingModule),
        canActivate: [LoggedInGuard]
      },
      {
        path: "preordini",
        loadChildren: () => import("./pages/preordini/preordini-routing.module").then(m => m.PreordiniRoutingModule),
        canActivate: [LoggedInGuard]
      },
      {
        path: "movimenti-magazzino",
        loadChildren: () => import("./pages/movimenti-magazzino/movimenti-routing.module").then(m => m.MovimentiRoutingModule),
        canActivate: [LoggedInGuard]
      },
      {
        path: "listini",
        loadChildren: () => import("./pages/listini/listini-routing.module").then(m => m.ListiniRoutingModule),
        canActivate: [LoggedInGuard]
      },
      {
        path: "thankyou",
        loadChildren: () => import("./pages/thankyou-page/thankyou-page-routing.module").then(m => m.ThankyouPageRoutingModule),
        canActivate: [LoggedInGuard]
      },
      {
        path: "products/detail/:id",
        loadComponent: () => import("./pages/product-detail/product-detail.component").then(m => m.ProductDetailComponent),
        canActivate: [LoggedInGuard]
      },
      {
        path: "collections",
        loadComponent: () => import("./pages/collections/collections.component").then(m => m.CollectionsComponent),
        canActivate: [LoggedInGuard]
      },
      {
        path: "collections/detail/:id",
        loadComponent: () => import("./pages/collections/collection-detail/collection-detail.component").then(m => m.CollectionDetailComponent),
        canActivate: [LoggedInGuard]
      },
      {
        path: "colors",
        loadComponent: () => import("./pages/colors/colors.component").then(m => m.ColorsComponent),
        canActivate: [LoggedInGuard]
      },
      {
        path: "colors/detail/:id",
        loadComponent: () => import("./pages/colors/color-detail/color-detail.component").then(m => m.ColorsDetailComponent),
        canActivate: [LoggedInGuard]
      },
      {
        path: "fabrics",
        loadComponent: () => import("./pages/fabrics/fabrics.component").then(m => m.FabricsComponent),
        canActivate: [LoggedInGuard]
      },
      {
        path: "fabrics/detail/:id",
        loadComponent: () => import("./pages/fabrics/fabric-detail/fabric-detail.component").then(m => m.FabricsDetailComponent),
        canActivate: [LoggedInGuard]
      },


      {
        path: "",
        redirectTo: "dashboard",
        pathMatch: "full"
      }
    ],

  },
  {
    path: "",
    component: LoginLayoutComponent,
    children: [
      {
        path: "login",
        loadChildren: () => import("./pages/login/login.module").then(m => m.LoginModule),
        canActivate: [NotLoggedInGuard]
      },
      {
        path: "sign-up",
        loadChildren: () => import("./pages/sign-up/sign-up.module").then(m => m.SignUpModule),
        canActivate: [NotLoggedInGuard]
      },
      {
        path: "**",
        redirectTo: "login"
      }

    ],
  },
  {
    path: "**",
    redirectTo: "login"
  }
]

@NgModule({
  imports: [RouterModule.forRoot(routes, {scrollPositionRestoration : 'top',anchorScrolling: 'enabled'})],
  exports: [RouterModule]
})
export class AppRoutingModule { }
